import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// the translations
// (tip move them in a JSON file and import them)
export const languages = ['en', 'pl'];
const resources = {
  en: {
    translation: {
      'Additional comments': 'Additional comments',
      administrator: 'administrator',
      'Adres zapisanego projektu': 'The address of the saved project',
      'Cena': 'price',
      'Ceny netto, „LOCO Ogorzelice / Dobrzyńska / Kobiałka': 'Net prices, "LOCO Ogorzelice / Dobrzyńska / Kobiałka.{',
      'Bolted frame': 'Bolted frame',
      'chosen parameters': 'Chosen parameters',
      'columns number': 'columns number',
      company: 'Company',
      configurator: 'configurator',
      'Construction variant': 'Construction variant:',
      'Color of outer cladding': 'Color of outer cladding:',
      'Container options': 'Container options:',
      'containers number': 'containers number',
      'Continue without login': 'Continue without login',
      'Currency': 'Currency',
      custommer: 'custommer',
      'date send': 'Date send',
      discount: 'Discount',
      'Drainage': 'drainage',
      'Elementy': 'Elements',
      'Elementy dodatkowe': 'Additional elements',
      'Estimation': 'Estimation',
      'first name': 'Name',
      'floor': 'floor',
      'floor number': 'floor number',
      'Frame color': 'Frame color:',
      'grouping by': 'grouping by',
      guest: 'guest',
      'ilość': 'quantity',
      'in the name of client': 'in the name of client',
      'individual project': 'Individual project',
      inquiries: 'Inquiries',
      'insert selected containers': 'Insert selected containers',
      'insert title': 'INSERT TITLE',
      'Insulation in the floor': 'Insulation in the floor:',
      'Insulation in panel walls': 'Insulation in panel walls:',
      'Izolacja w dachu': 'Roof insulation:',
      'Izolacja w podlodze': 'Insulation in the floor:',
      'Izolacja w ścianach paneli': 'Insulation in panel walls:',
      'Kieszenie transportowe': 'Transport pockets:',
      'Kolor okładziny zewnętrznej': 'Color of outer cladding:',
      'Kolor ramy': 'Frame color:',
      'kondygnacja': 'floor',
      'last name': 'Last name',
      load: "load",
      'log out': 'log out',
      'log in': 'log in',
      login: 'login',
      'main page': 'main page',
      'make project': 'design',
      'ManyFloors': 'many floors',
      'ModuleHeight': 'module height',
      'ModuleLength': 'module length',
      'ModuleWidth': 'module width',
      'netto price': 'netto price',
      'new': 'New',
      'NIE': 'no',
      'Nie': 'No',
      no: 'No',
      'no privileges - go back': 'no privileges - go back',
      'no title': 'no title',
      none: 'brak',
      'Obróbki': 'Finishings',
      'nr': 'no',
      'of containers': 'of containers',
      'of customers': 'of customers',
      'Opcje konteneru': 'Container options:',
      'Opis dodatkowy...': 'Additional description...',
      'perimeter gutter': 'perimeter gutter',
      phone: 'phone',
      price: 'Price',
      PriceGroup: 'Price group',
      'privacy policy': 'PRIVICY POLICY',
      'project code': 'Project code',
      'project name': 'Project name',
      'project title': 'project title',
      project: 'project',
      projects: 'projects',
      'Rama skręcana': 'Bolted frame',
      'Rama Skręcana': 'Bolted Frame',
      'Razem': 'All',
      removed: 'removed',
      'Podana wycena jest wersją roboczą, do potwierdzenia przez Dział Wycen Modular System': 'The quote provided is a draft version, subject to confirmation by the Modular System Quoting Department.',
      role: 'Role',
      'Roof insulation': 'Roof insulation:',
      'row number': 'row number',
      'Sanitarne - Izolacja w podlodze': 'Sanitary - Insulation in the floor:',
      'Sanitarne - Izolacja w dachu': 'Sanitary - Roof insulation:',
      'Sanitarne - Izolacja w ścianach paneli': 'Sanitary - Insulation in panel walls:',
      'Sanitary - Insulation in the floor': 'Sanitarne - Izolacja w podlodze:',
      'Sanitary - Insulation in panel walls': 'Sanitary - Insulation in panel walls:',
      'Sanitary - Roof insulation': 'Sanitary - Roof insulation:',
      saved: 'saved',
      'see all inquires': 'See all inquires',
      seller: 'seller',
      'Schema with corridor': 'Schema with corridor',
      'Schema without corridor': 'Schema without corridor',
      'start empty': 'Start empty project',
      sudo: 'developer',
      'Szczegóły projektu': 'Project details',
      'TAK': 'YES',
      'through walls': 'through walls',
      'total number': 'total number',
      'Transport pockets': 'Transport pockets:',
      'trade supervisor': 'Trade supervisor',
      'typ': 'typ',
      users: 'Users',
      ustawienia: 'settings',
      'uwagi': 'additional description',
      'Uwagi dodatkowe': 'Additional description',
      'Wariant konstrukcji': 'Construction variant',
      'Wczytaj projekt': 'Load project',
      'Wczytaj w imieniu klienta': 'Load on behalf of the client',
      'with configurator': 'design of configurator',
      "Dach Biurowy Standard": "Standard Office Roof",
      "Dach Biurowy Opcja": "Optional Office Roof",
      "Dach Sanitarny Standard": "Standard Sanitary Roof",
      "Dach Sanitarny Opcja": "Optional Sanitary Roof",
      "Podloga Biurowa Standard": "Standard Office Floor",
      "Podloga Biurowa Opcja": "Optional Office Floor",
      "Podloga Sanitarna Standard": "Standard Sanitary Floor",
      "Podloga Sanitarna Opcja": "Optional Sanitary Floor",
      "Panel Pelny Biurowy Opcja": "Optional Full Office Panel",
      "Panel okienny biurowy w kontenerze biurowym": "Office Window Panel in Office Container",
      "Panel okienny sanitarny w kontenerze biurowym": "Sanitary Window Panel in Office Container",
      "Panel Drzwiowy Biurowy Opcja": "Optional Office Door Panel",
      "Panel Pusty Otwór Biurowy Opcja": "Optional Office Empty Opening Panel",
      "Panel Drzwiowy Szklany Biurowy Opcja": "Optional Office Glass Door Panel",
      "Panel Drzwiowy Podwójny Biurowy Opcja": "Optional Office Double Door Panel",
      "Panel Okienny Podawczy Biurowy Opcja": "Optional Office Service Window Panel",
      "Panel Okienny Panoramiczny Biurowy Opcja": "Optional Office Panoramic Window Panel",
      "Panel Pelny Biurowy Standard": "Full Office Standard Panel",
      "Panel okienny biurowy w kontenerze biurowym standard": "Office window panel in a standard office container",
      "Panel Drzwiowy Biurowy Standard": "Standard Office Door Panel",
      "Panel Drzwiowy Szklany Biurowy Standard": "Standard Office Glass Door Panel",
      "Zestawy transportowe flatpack zwykle": "Flatpack transport kits usually",
    },
  },
  pl: {
    translation: {
      'Additional comments': 'Uwagi dodatkowe',
      administrator: 'administrator',
      'Adres zapisanego projektu': 'Adres zapisanego projektu',
      'Bolted frame': 'Rama skręcana',
      'back': 'powrót',
      'Cena': 'Cena',
      'Ceny netto, „LOCO Ogorzelice / Dobrzyńska / Kobiałka': 'Ceny netto, „LOCO Ogorzelice / Dobrzyńska / Kobiałka.',
      'chosen parameters': 'Wybór parametrów',
      'columns number': 'liczba kolumn',
      company: 'Firma',
      configurator: 'konfigurator',
      'Construction variant': 'Wariant konstrukcji:',
      'Color of outer cladding': 'Kolor okładziny zewnętrznej:',
      'Continue without login': 'Projektuj bez logowania',
      'containers number': 'liczba kontenerów',
      'Container options': 'Opcje konteneru',
      'Currency': 'Waluta',
      custommer: 'klient',
      'date send': 'Data przesłania',
      discount: 'Rabat',
      'Drainage': 'odwodnienie',
      'Elementy': 'Elementy',
      'Elementy dodatkowe': 'Elementy dodatkowe',
      'Estimation': 'Kosztorys',
      'first name': 'Imie',
      'floor': 'kondygnacja',
      'floor number': 'liczba kondygnacji',
      'Frame color': 'Kolor ramy:',
      'grouping by': 'grupy po',
      guest: 'gość',
      'ilość': 'ilość',
      'in the name of client': 'w imieniu klienta',
      'individual project': 'Projekt własny',
      inquiries: 'Zapytania',
      'insert selected containers': 'Wstaw zaznaczone kontenery',
      'insert title': 'WPISZ TYTUŁ',
      'Insulation in panel walls': 'Izolacja w ścianach paneli:',
      'Insulation in the floor': 'Izolacja w podlodze:',
      'Izolacja w dachu': 'Izolacja w dachu:',
      'Izolacja w podlodze': 'Izolacja w podlodze:',
      'Izolacja w ścianach paneli': 'Izolacja w ścianach paneli:',
      'Kieszenie transportowe': 'Kieszenie transportowe:',
      'Kolor okładziny zewnętrznej': 'Kolor okładziny zewnętrznej:',
      'Kolor ramy': 'Kolor ramy:',
      'kondygnacja': 'kondygnacja',
      'last name': 'Nazwisko',
      load: "wczytaj",
      'log out': 'wyloguj',
      'log in': 'zaloguj',
      login: 'logowanie',
      'main page': 'strona główna',
      'make project': 'projektuj',
      'ManyFloors': 'wiele kondygnacji',
      'ModuleHeight': 'wysokość modułu',
      'ModuleLength': 'długość modułu',
      'ModuleWidth': 'szerokość modułu',
      'netto price': 'wartość netto',
      'new': 'Nowy',
      'NIE': 'nie',
      'Nie': 'nie',
      no: 'Nr',
      'nr': 'nr',
      'no privileges - go back': 'brak uprawnień - powrót',
      'no title': 'bez nazwy',
      none: 'none',
      'Obróbki': 'Obróbki',
      'of containers': 'kontenerów',
      'of customers': 'klientów',
      'Opcje konteneru': 'Opcje konteneru:',
      'Opis dodatkowy...': 'Opis dodatkowy...',
      'perimeter gutter': 'rynna obwiedniowa',
      phone: 'telefon',
      price: 'Cena',
      PriceGroup: 'Grupa cenowa',
      'privacy policy': 'POLITYKA PRYWATNOŚCI',
      'project code': 'Kod projektu',
      'project name': 'Nazwa projektu',
      'project title': 'nazwie',
      project: 'projekt',
      projects: 'projekty',
      'Rama skręcana': 'Rama skręcana',
      'Rama Skręcana': 'Rama Skręcana',
      'Razem': 'Razem',
      removed: 'usunięty',
      'Podana wycena jest wersją roboczą, do potwierdzenia przez Dział Wycen Modular System': 'Podana wycena jest wersją roboczą, do potwierdzenia przez Dział Wycen Modular System.',
      role: 'Rola',
      'Roof insulation': 'Izolacja w dachu:',
      'row number': 'liczba wierszy',
      'Sanitarne - Izolacja w podlodze': 'Sanitarne - Izolacja w podlodze:',
      'Sanitarne - Izolacja w dachu': 'Sanitarne - Izolacja w dachu:',
      'Sanitarne - Izolacja w ścianach paneli': 'Sanitarne - Izolacja w ścianach paneli:',
      'Sanitary - Insulation in the floor': 'Sanitarne - Izolacja w podlodze:',
      'Sanitary - Roof insulation': 'Sanitarne - Izolacja w dachu:',
      'Sanitary - Insulation in panel walls': 'Sanitary - Izolacja w ścianach paneli:',
      saved: 'zapisane',
      'see all inquires': 'Zobacz wszystkie zapytania',
      seller: 'sprzedawca',
      'Schema with corridor': 'Układ z korytarzem',
      'Schema without corridor': 'Układ bez korytarza',
      'start empty': 'Rozpocznij bez wstawiania',
      sudo: 'programista',
      'Szczegóły projektu': 'Szczegóły projektu',
      'TAK': 'tak',
      'through walls': 'przez ściany',
      'total number': 'łączna liczba',
      'trade supervisor': 'Opiekun handlowy',
      'Transport pockets': 'Kieszenie transportowe:',
      'typ': 'type',
      users: 'Użytkownicy',
      ustawienia: 'ustawienia',
      'uwagi': 'Uwagi dodatkowe',
      'Uwagi dodatkowe': 'Uwagi dodatkowe',
      'Wariant konstrukcji': 'Wariant konstrukcji',
      'Wczytaj projekt': 'Wczytaj projekt',
      'Wczytaj w imieniu klienta': 'Wczytaj w imieniu klienta',
      'with configurator': 'konfiguratora',
      "Dach Biurowy Standard": "Dach Biurowy Standard",
      "Dach Biurowy Opcja": "Dach Biurowy Opcja",
      "Dach Sanitarny Standard": "Dach Sanitarny Standard",
      "Dach Sanitarny Opcja": "Dach Sanitarny Opcja",
      "Podloga Biurowa Standard": "Podloga Biurowa Standard",
      "Podloga Biurowa Opcja": "Podloga Biurowa Opcja",
      "Podloga Sanitarna Standard": "Podloga Sanitarna Standard",
      "Podloga Sanitarna Opcja": "Podloga Sanitarna Opcja",
      "Panel Pelny Biurowy Opcja": "Panel Pelny Biurowy Opcja",
      "Panel okienny biurowy w kontenerze biurowym": "Panel okienny biurowy w kontenerze biurowym",
      "Panel okienny sanitarny w kontenerze biurowym": "Panel okienny sanitarny w kontenerze biurowym",
      "Panel Drzwiowy Biurowy Opcja": "Panel Drzwiowy Biurowy Opcja",
      "Panel Pusty Otwór Biurowy Opcja": "Panel Pusty Otwór Biurowy Opcja",
      "Panel Drzwiowy Szklany Biurowy Opcja": "Panel Drzwiowy Szklany Biurowy Opcja",
      "Panel Drzwiowy Podwójny Biurowy Opcja": "Panel Drzwiowy Podwójny Biurowy Opcja",
      "Panel Okienny Podawczy Biurowy Opcja": "Panel Okienny Podawczy Biurowy Opcja",
      "Panel Okienny Panoramiczny Biurowy Opcja": "Panel Okienny Panoramiczny Biurowy Opcja",
      "Panel Pelny Biurowy Standard": "Panel Pelny Biurowy Standard",
      "Panel okienny biurowy w kontenerze biurowym standard": "Panel okienny biurowy w kontenerze biurowym standard",
      "Panel Drzwiowy Biurowy Standard": "Panel Drzwiowy Biurowy Standard",
      "Panel Drzwiowy Szklany Biurowy Standard": "Panel Drzwiowy Szklany Biurowy Standard",
      "Zestawy transportowe flatpack zwykle": "Zestawy transportowe flatpack zwykle",

    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;
